<cb-dialog [dialogHeading]="data.heading">
    <form class="flex-col"
          #form="ngForm">
        @if (data.formInputConfig.type === SIMPLE_FORM_INPUT_TYPE.Textarea) {
            <cb-text-area
                name="textarea"
                [label]="data.formInputConfig.label"
                [(ngModel)]="data.value"
                [maxlength]="data.formInputConfig.maxlength"
                [required]="data.formInputConfig.required"></cb-text-area>
        }
        @if (data.formInputConfig.type === SIMPLE_FORM_INPUT_TYPE.DatePicker) {
            <cb-datepicker
                name="datePicker"
                [label]="data.formInputConfig.label"
                [(ngModel)]="data.value"
                [required]="data.formInputConfig.required"
                pickerType="calendar"></cb-datepicker>
        }
    </form>
    <div actions>
        <button color="primary"
                mat-raised-button
                [disabled]="form.invalid || (form.pristine && !data.formInputConfig.required)"
                (click)="save()">{{ data.yesLabel }}
        </button>
        <button mat-raised-button
                (click)="close()">{{ data.noLabel }}
        </button>
    </div>
</cb-dialog>
